import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CircularProgress } from '@mui/material';

export interface ConfirmDialogI {
  id: string;
  open: boolean;
  question: string;
  questionDescription: string;
  primaryButtonLabel: string;
  primaryAction: any;
  secondaryButtonLabel: string;
  secondaryAction: any;
  onClose?: any;
}

export default function ConfirmDialog(props: ConfirmDialogI) {
  const {
    id,
    open,
    question,
    questionDescription,
    primaryButtonLabel,
    primaryAction,
    secondaryButtonLabel,
    secondaryAction,
    onClose,
  } = props;

  const [isOpen, setOpen] = React.useState<boolean>(open);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    setOpen(open);
  }, [open]);

  const handleClose = () => {
    if (loading) {
      return;
    }
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      id={id}
      open={isOpen}
      onClose={() => handleClose()}
      aria-labelledby={`${id}-alert-dialog-title`}
      aria-describedby={`${id}-alert-dialog-description`}
    >
      <DialogTitle id={`${id}-alert-dialog-title`}>{question}</DialogTitle>
      <DialogContent>
        <DialogContentText id={`${id}-alert-dialog-description`}>
          {questionDescription}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={loading}
          variant='outlined'
          onClick={() => {
            handleClose();
            secondaryAction();
          }}
        >
          {secondaryButtonLabel}
        </Button>
        <Button
          disabled={loading}
          variant='contained'
          onClick={async () => {
            setLoading(true);
            try {
              await primaryAction();
            } finally {
              setLoading(false);
            }
            handleClose();
          }}
          endIcon={
            loading ? <CircularProgress size='1rem' color='inherit' /> : ''
          }
        >
          {primaryButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
